import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import config from '../../../../../../../../../config'
import Tabs from '../../../../../../../../../components/Tabs'
import GoogleMap from '../../../../../../../../../components/GoogleMap'
import Collapse from '../../../../../../../../../components/Collapse'
import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Address from './components/Address'
import FirmsOnAddress from './components/FirmsOnAddress'

import { getAllAddresses } from './helpers'

import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
@hocConnect
export default class Addresses extends Component {
    static propTypes = {
        addressesRuianIdChange: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        firmsOnAddressSummary: PropTypes.object,
        googleMapToggleCollapsed: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        mapCollapsed: PropTypes.bool,
        isScrolled: PropTypes.string,
        module: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
    }

    static defaultProps = {
        mapCollapsed: false,
        isScrolled: false,
    }

    componentDidMount() {
        const {
            module,
            block,
            id,
            customData,
            level,
            addressesRuianIdChange,
            setIsScrolled,
            isScrolled,
            scrollTo,
            scrollRefs,
        } = this.props

        const ruianId = _.get(customData, 'activeAddress.ruianId', null)

        if (isScrolled === 'addresses') {
            scrollTo(scrollRefs.addresses)
            setIsScrolled(false)
        }

        addressesRuianIdChange(module, id, block, level, customData, ruianId)
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.block !== nextProps.block) return true
        if (this.props.mapCollapsed !== nextProps.mapCollapsed) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    componentDidUpdate(prevProps) {
        const { module, block, id, customData, level, addressesRuianIdChange } = this.props

        const prevRuian = _.get(prevProps, 'customData.activeAddress.ruianId', null)
        const ruianId = _.get(customData, 'activeAddress.ruianId', null)

        if (prevRuian !== ruianId) addressesRuianIdChange(module, id, block, level, customData, ruianId)
    }

    handleDropdownClick = () => {
        const { id, mapCollapsed, googleMapToggleCollapsed } = this.props

        googleMapToggleCollapsed(id, !mapCollapsed)
    }

    render() {
        const {
            id,
            module,
            block,
            level,
            data,
            transformedData,
            intl,
            customData,
            firmsOnAddressSummary,
            mapCollapsed,
        } = this.props

        return (
            <div className={cx('block-addresses')}>
                <Tabs
                    level={level}
                    id={`addresses-tabs-${id}`}
                    key={`addresses-tabs-${id}`}
                    tabs={[
                        {
                            content: () => (
                                <Address
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    data={{
                                        summary: _.get(data, '[0]', {}),
                                        tables: _.get(transformedData, 'addressTables', {}),
                                    }}
                                    customData={customData}
                                />
                            ),
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.addresses` }),
                            counter: {
                                left: _.get(data, '[0].activeAddresses', 0),
                                right: _.get(data, '[0].totalAddresses', 0),
                            },
                        },
                        {
                            content: () => (
                                <FirmsOnAddress
                                    id={id}
                                    module={module}
                                    block={block}
                                    level={level}
                                    ruianId={_.get(customData, 'activeAddress.ruianId', null)}
                                    data={{
                                        address: _.get(customData, 'activeAddress', null),
                                        summary: _.get(customData, 'firmsOnAddress.summary', {}),
                                        table: _.get(customData, 'firmsOnAddress.table', {}),
                                    }}
                                    customData={customData}
                                />
                            ),
                            counter: {
                                left: _.get(firmsOnAddressSummary, 'activeSubjects', 0),
                                right: _.get(firmsOnAddressSummary, 'totalSubjects', 0),
                            },
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.firmsOnAdresses` }),
                            disabled: _.isNil(_.get(customData, 'activeAddress.ruianId', null)),
                        },
                    ]}
                />
                <div className={'google-maps-container'}>
                    <div
                        className={cx('dropdown-container', mapCollapsed && 'collapsed')}
                        onClick={() => this.handleDropdownClick()}
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.mapOfAddress`}
                            values={{ address: _.get(customData, 'activeAddress.value', null) }}
                        />
                    </div>
                    <Collapse expand={!mapCollapsed} duration={500}>
                        <GoogleMap
                            id={id}
                            addresses={getAllAddresses(_.get(transformedData, 'addressTables', {}))}
                            activeAddress={_.get(customData, 'activeAddress', {})}
                        />
                    </Collapse>
                </div>
            </div>
        )
    }
}
